import {
  Building2,
  Landmark,
  Globe2,
  Handshake,
  FileCheck,
  Home,
  Plane,
  ArrowRight,
} from "lucide-react";

function BusinessSetUp() {
  return (
    <div className="py-10 sm:py-16 lg:py-24">
      {/* Hero Section */}
      <header className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="flex items-start gap-3 mb-4">
            <Building2 className="w-8 h-8" />
            <h1 className="text-2xl lg:text-4xl font-bold">
              Scan Global Holdings
            </h1>
          </div>
          <p className="text-base lg:text-xl text-slate-300 max-w-2xl">
            Empowering entrepreneurs and investors to establish thriving
            businesses in the UAE
          </p>
        </div>
      </header>

      {/* Business Setup Section */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Side - Description */}
          <div>
            <div className="inline-block px-4 py-2 bg-slate-800 rounded-full mb-6">
              <span className="text-sm font-semibold  uppercase tracking-wide">
                Business Setup
              </span>
            </div>
            <h2 className="text-2xl lg:text-4xl font-bold text-white mb-6 leading-tight">
              Build Your Business in the UAE with Confidence
            </h2>
            <div className="prose prose-lg text-slate-400 space-y-4">
              <p>
                At Scan Global Holdings, we help entrepreneurs, investors, and
                companies establish a strong foundation in the UAE.
              </p>
              <p>
                From licensing to logistics, Wahaj and the Scan team simplify
                every step of the business setup process ensuring your
                operations comply with UAE regulations and thrive in one of the
                world's fastest-growing markets.
              </p>
            </div>
          </div>

          {/* Right Side - Services Chart */}
          <div className="relative">
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-4 lg:p-8 shadow-xl">
              <h3 className="text-2xl font-bold text-white mb-2">
                Apply through:
              </h3>
              <p className="text-slate-300 text-sm mb-8">
                Choose the business structure that fits your goals
              </p>

              {/* Flow Chart */}
              <div className="space-y-4">
                <ChartItem
                  icon={<Landmark className="w-5 h-5" />}
                  title="Mainland Business Setup"
                  description="Trade freely across the UAE with local or full ownership options."
                  step="01"
                />
                <ChartConnector />
                <ChartItem
                  icon={<Building2 className="w-5 h-5" />}
                  title="Free Zone Formation"
                  description="100% foreign ownership and tax benefits in top UAE free zones."
                  step="02"
                />
                <ChartConnector />
                <ChartItem
                  icon={<Globe2 className="w-5 h-5" />}
                  title="Offshore Company Registration"
                  description="Ideal for international investors seeking strategic access and privacy."
                  step="03"
                />
                <ChartConnector />
                <ChartItem
                  icon={<Handshake className="w-5 h-5" />}
                  title="Corporate Structuring & Partnerships"
                  description="Build strong local alliances to expand your reach."
                  step="04"
                />
                <ChartConnector />
                <ChartItem
                  icon={<FileCheck className="w-5 h-5" />}
                  title="Legal & Compliance Services"
                  description="Streamlined documentation, licensing, and regulatory guidance."
                  step="05"
                />
                <ChartConnector />
                <ChartItem
                  icon={<Home className="w-5 h-5" />}
                  title="Commercial Real Estate Solutions"
                  description="Find, negotiate, and secure premium office or retail spaces to lease or purchase."
                  step="06"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function ChartItem({ icon, title, description, step }) {
  return (
    <div className="relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5 hover:bg-white/15 transition-all duration-300 group">
      <div className="flex gap-4">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-white text-slate-900 rounded-lg flex items-center justify-center mb-2">
            {icon}
          </div>
          <div className="text-xs font-bold text-slate-400 text-center">
            {step}
          </div>
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-white mb-2 group-hover:text-gold transition-colors">
            {title}
          </h4>
          <p className="text-sm text-slate-300 leading-relaxed">
            {description}
          </p>
        </div>
        <div className="flex-shrink-0 self-center opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowRight className="w-5 h-5 text-gold" />
        </div>
      </div>
    </div>
  );
}

function ChartConnector() {
  return (
    <div className="flex justify-center">
      <div className="w-0.5 h-4 bg-gradient-to-b from-white/30 to-white/10"></div>
    </div>
  );
}

export default BusinessSetUp;
